/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2021-10-20 17:10:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/TextArea/TextArea.tsx
 */
import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { controlSymbolFilter } from '@/src/tools/helper';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Input as InputAntd } from 'antd';
import React, { ReactNode } from 'react';
import { EnumFormItemStatus } from 'src/types/common/validation';
import css from './TextArea.less';

const { TextArea: TextAreaAntd } = InputAntd;
interface IProps {
  className?;
  prefix?;
  onPressEnter?;
  onChange?;
  value?;
  placeholder?;
  allowClear?;
  autoSize?;
  maxLength?;
  size?;
  disabled?;
  status?: EnumFormItemStatus;
  help?: string | ReactNode;
  error?: boolean;
  customFilter?: (a: string) => string;
  min?: number;
  max?: number;
}

const TextArea = (props: IProps) => {
  const {
    className,
    onChange,
    prefix,
    onPressEnter,
    value,
    placeholder,
    allowClear,
    autoSize,
    maxLength,
    size,
    help,
    customFilter,
    error,
    ...rest
  } = props;
  const textOnchange = (e) => {
    if (onChange) {
      let value = e.target.value || '';

      value = controlSymbolFilter(value);
      if (customFilter) {
        value = customFilter(value);
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      onChange(value, e);
    }
  };

  return (
    <FormItem
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
      })}>
      <TextAreaAntd
        // onCompositionStartCapture={(e) => {
        //   console.log(e);
        // }}
        className={className ? className : css.textAreaClass}
        onChange={textOnchange}
        autoSize={autoSize}
        prefix={prefix}
        onPressEnter={onPressEnter}
        placeholder={placeholder}
        value={value}
        allowClear={allowClear}
        {...(maxLength && { maxLength })}
        size={size}
        {...rest}
      />
    </FormItem>
  );
};
export default TextArea;
